import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationResponseService } from 'src/app/services/authentication-response.service';

@Component({
  selector: 'app-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent {
  
  constructor(public translate: TranslateService,
    private authenticationResponseService: AuthenticationResponseService) {
  }

  selectedLang(eventData: { lang: string }) {
    this.translate.use(eventData.lang);
  }

  ngOnInit(): void {
    this.authenticationResponseService.response$.subscribe(response => {
      this.translate.setDefaultLang('en');
      this.translate.use('en');
    });
  }
}